import * as React from 'react';
import { ContextualMenu, DirectionalHint } from 'office-ui-fabric-react/lib';
import { DateTimePicker } from 'owa-datetimepicker';
import { hideTodoContextMenu } from '../actions/todoFolderViewStateActions';
import { InlineDatePicker } from 'owa-datepicker';
import { OwaDate, now } from 'owa-datetime';
import { updateTodoDueDate, updateTodoReminder } from '../actions/todoActions';
import getDefaultReminderDateTime from '../utils/getDefaultReminderDateTime';
import getSelectedFolderViewState from '../selectors/getSelectedFolderViewState';
import getTodoContextMenuItems from '../utils/getTodoContextMenuItems';
import selectTodoById from '../selectors/selectTodoById';
import isTaskInActiveList from '../utils/isTaskInActiveList';

export default class TodoContextMenu extends React.Component<{}, {}> {
    render() {
        const contextMenuState = getSelectedFolderViewState().contextMenuViewState;
        const item = selectTodoById(contextMenuState.itemId);

        if (item === null) {
            return null;
        }

        // If it's not in an active list, we won't support reordering.
        const canReorder = isTaskInActiveList(contextMenuState.itemId);

        return (
            <ContextualMenu
                shouldFocusOnMount={true}
                target={contextMenuState.anchor}
                directionalHint={DirectionalHint.bottomLeftEdge}
                onDismiss={this.onDismiss}
                items={getTodoContextMenuItems(
                    contextMenuState.itemId,
                    this.renderReminderPicker,
                    this.renderDueDatePicker,
                    canReorder
                )}
                calloutProps={{ preventDismissOnScroll: true }}
            />
        );
    }

    private onDismiss() {
        hideTodoContextMenu();
    }

    private renderReminderPicker = (): JSX.Element => {
        const contextMenuState = getSelectedFolderViewState().contextMenuViewState;
        const item = selectTodoById(contextMenuState.itemId);

        if (item === null) {
            return null;
        }

        const reminderTime = item.ReminderDateTime
            ? item.ReminderDateTime
            : getDefaultReminderDateTime(now());

        return (
            <DateTimePicker
                value={reminderTime}
                onSave={this.onReminderSave}
                onCancel={this.onReminderCancel}
            />
        );
    };

    private renderDueDatePicker = (): JSX.Element => {
        const contextMenuState = getSelectedFolderViewState().contextMenuViewState;
        const item = selectTodoById(contextMenuState.itemId);

        if (item === null) {
            return null;
        }

        const dueDate = item.DueDateTime ? item.DueDateTime : getDefaultReminderDateTime(now());

        return (
            <InlineDatePicker
                value={dueDate}
                highlightCurrentMonth={false}
                highlightSelectedMonth={true}
                isDayPickerVisible={true}
                showGoToToday={false}
                onSelectDate={this.onDueDateSave}
            />
        );
    };

    private onReminderSave(selectedReminderTime: OwaDate) {
        const contextMenuState = getSelectedFolderViewState().contextMenuViewState;
        updateTodoReminder(contextMenuState.itemId, selectedReminderTime);
        hideTodoContextMenu();
    }

    private onReminderCancel() {
        hideTodoContextMenu();
    }

    private onDueDateSave(selectedDueDateTime: OwaDate) {
        const contextMenuState = getSelectedFolderViewState().contextMenuViewState;
        updateTodoDueDate(contextMenuState.itemId, selectedDueDateTime);
        hideTodoContextMenu();
    }
}
